module.exports = __webpack_public_path__ + "img/tradexc_icon_logo.c8b6d1c8.png";